<ng-container  *transloco="let t; read: 'ime.components.dashboard'">
  <span class="text-orange-300" [ngClass]="{'hover-icon' : !isFavourite, 'hover-icon-active' : isFavourite}" [ngbTooltip]="isFavourite ? t('Remove from favourites') : t('Add to favourites')">
    <svg viewBox="0 0 8 8" class="icon small mb-1 ms-1" [inlineSVG]="'#star'" (click)="toggleFavouriteStatus()"></svg>
  </span>
</ng-container>
